/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import TransactionDetailsModal from "./Modals/TransactionDetailsModal";
import styles from "./styles.module.css";
import { formatCurrency } from "../../../../utils/currency";
import Mail from "../../../../assets/icon/mail-01.svg";
import Expand from "../../../../assets/icon/expand-01.svg";
import BankReferenceModal from "./Modals/BankRefereneModal";
import SendMailModal from "./Modals/SendMailModal";
import moment from "moment";
import PaymentsModal from "./Modals/PaymentsModal";
import UpdateStatusModal from "./Modals/UpdateStatusModal";
import { updatePayoutById } from "../../../../store/actions/payout";
import { toast } from "react-toastify";

const PaymentTable = ({ columns, data, type, handleFunction }) => {
  const [transactionModal, setTransactionModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState({});
  const [bankReferenceModal, setBankReferenceModal] = useState(false);
  const [sendMailModal, setSendMailModal] = useState(false);
  const [paymentsModal, setPaymentsModal] = useState(false);
  const [paymentStatusModal, setPaymentStatusModal] = useState(false);

  const handleApproveAndPay = async (payout) => {
    const teacherName = payout?.teacherId?.userId?.fullName ||
      (payout?.teacherId?.firstName?.data
        ? `${payout.teacherId.firstName.data} ${payout.teacherId.lastName?.data || ""}`
        : "Teacher");
    const amount = payout?.amount || payout?.withdrawalAmount || 0;

    if (window.confirm(`This will transfer ₹${amount} to ${teacherName} immediately. Confirm?`)) {
      const result = await updatePayoutById(payout._id, {
        status: "Completed",
      });

      if (result.success) {
        toast.success("Payout initiated successfully");
        if (handleFunction) handleFunction();
      } else {
        toast.error(result.message || "Failed to initiate payout");
      }
    }
  };

  const handleReject = async (payout) => {
    if (window.confirm("Are you sure you want to REJECT this payout? The balance will be refunded to the teacher's wallet.")) {
      const result = await updatePayoutById(payout._id, {
        status: "Rejected",
      });

      if (result.success) {
        toast.info("Payout rejected and balance refunded.");
        if (handleFunction) handleFunction();
      } else {
        toast.error(result.message || "Failed to reject payout");
      }
    }
  };

  return (
    <>
      {transactionModal ? (
        <TransactionDetailsModal
          setTransactionModal={setTransactionModal}
          data={selectedTransaction}
          payouts={data}
          setPayouts={handleFunction}
        />
      ) : (
        <></>
      )}

      {paymentsModal ? (
        <PaymentsModal
          setPaymentsModal={setPaymentsModal}
          data={selectedTransaction}
        />
      ) : (
        <></>
      )}

      {bankReferenceModal ? (
        <BankReferenceModal
          setBankReferenceModal={setBankReferenceModal}
          data={selectedTransaction}
          payouts={data}
          setPayouts={handleFunction}
        />
      ) : (
        <></>
      )}

      {sendMailModal ? (
        <SendMailModal
          setSendMailModal={setSendMailModal}
          data={selectedTransaction}
          payouts={data}
          setPayouts={handleFunction}
        />
      ) : (
        <></>
      )}

      {paymentStatusModal ? (
        <UpdateStatusModal
          setPaymentStatusModal={setPaymentStatusModal}
          data={selectedTransaction}
          payouts={data}
          setPayouts={handleFunction}
        />
      ) : (
        <></>
      )}

      <div className={styles.payment_sheet}>
        <table className={styles.payment_table}>
          <thead>
            <tr className={styles.payment_table_heading}>
              {columns && columns.map((name, i) => <th key={i}>{name}</th>)}
            </tr>
          </thead>

          <tbody>
            {data &&
              type === "Transactions" &&
              data.map((e) => {
                const teacherName = e?.teacherId?.firstName?.data
                  ? `${e.teacherId.firstName.data} ${e.teacherId.lastName?.data || ""}`
                  : e?.teacherId?.userId?.fullName || "-";

                const totalPaid = Number(e?.totalAfterDiscount || e?.total || e?.itemPrice || 0);
                const platformFee = Number(e?.platformFees || 0);
                const netEarning = totalPaid - platformFee;

                return (
                  <tr key={e._id} className={styles.table_row}>
                    <td style={{ fontSize: "0.85rem", color: "#666" }}>{e?._id}</td>
                    <td>{e?.studentId?.fullName || "-"}</td>
                    <td>{teacherName}</td>
                    <td>{e?.courseId?.title?.data ?? e?.courseId?.title ?? "-"}</td>
                    <td>
                      {e.createdAt
                        ? moment(e.createdAt).format("D-MM-YYYY h:mm a")
                        : "-"}
                    </td>
                    <td style={{ fontWeight: "600" }}>{formatCurrency(totalPaid)}</td>
                    <td style={{ color: "#d9534f" }}>{formatCurrency(platformFee)}</td>
                    <td style={{ fontWeight: "700", color: "#5cb85c" }}>{formatCurrency(netEarning)}</td>
                    <td>
                      <img
                        src={Expand}
                        className={styles.icons}
                        onClick={() => {
                          setSelectedTransaction(e);
                          setPaymentsModal(true);
                        }}
                        style={{ cursor: "pointer" }}
                        alt="Expand"
                      />
                    </td>
                  </tr>
                );
              })}

            {data &&
              type === "Payouts" &&
              data.map((e) => {
                const teacherName = e?.teacherId?.userId?.fullName ||
                  (e?.teacherId?.firstName?.data
                    ? `${e.teacherId.firstName.data} ${e.teacherId.lastName?.data || ""}`
                    : "Teacher");

                const gross = Number(e?.grossAmount || e?.withdrawalAmount || 0);
                const fee = Number(e?.platformFee || 0);
                const net = Number(e?.amount || (gross - fee));

                return (
                  <tr key={e._id} className={styles.table_row}>
                    <td>
                      <div style={{ display: "flex", alignItems: "center", gap: "10px", justifyContent: "center" }}>
                        <img
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            objectFit: "cover"
                          }}
                          src={e?.teacherId?.teacherProfilePic?.data || "https://ui-avatars.com/api/?name=" + teacherName}
                          alt={teacherName}
                        />
                        <span>{teacherName}</span>
                      </div>
                    </td>
                    <td>
                      {e.createdAt
                        ? moment(e.createdAt).format("D-MM-YYYY h:mm a")
                        : "-"}
                    </td>
                    <td>
                      <span style={{
                        padding: "4px 8px",
                        borderRadius: "12px",
                        fontSize: "0.85rem",
                        backgroundColor: e?.status === "Completed" ? "#dff0d8" : "#fcf8e3",
                        color: e?.status === "Completed" ? "#3c763d" : "#8a6d3b"
                      }}>
                        {e?.status || e?.paymentStatus || "Pending"}
                      </span>
                    </td>
                    <td style={{ fontWeight: "600" }}>{formatCurrency(gross)}</td>
                    <td style={{ color: "#d9534f" }}>{formatCurrency(fee)}</td>
                    <td style={{ fontWeight: "700", color: "#5cb85c" }}>{formatCurrency(net)}</td>
                    <td
                      style={{
                        display: "flex",
                        gap: "15px",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                      {e?.status === "Pending" && (
                        <div style={{ display: "flex", gap: "10px" }}>
                          <button
                            onClick={() => handleApproveAndPay(e)}
                            className={styles.approve_btn}
                            title="Approve & Pay (Automated)"
                          >
                            <i className="fas fa-check"></i> Approve
                          </button>
                          <button
                            onClick={() => handleReject(e)}
                            className={styles.reject_btn}
                            title="Reject Payout"
                          >
                            <i className="fas fa-times"></i> Reject
                          </button>
                        </div>
                      )}

                      <img
                        src={Mail}
                        className={styles.icons}
                        onClick={() => {
                          setSelectedTransaction(e);
                          setSendMailModal(true);
                        }}
                        title="Send Mail"
                        alt="Mail"
                      />
                      <img
                        src={Expand}
                        className={styles.icons}
                        onClick={() => {
                          setSelectedTransaction(e);
                          setTransactionModal(true);
                        }}
                        title="View Details"
                        alt="Expand"
                      />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PaymentTable;
